import Picker from '@emoji-mart/react';
interface Props {
	handleEmojiSelect: (e: any) => void;
	isLiveChat?: boolean;
}

const Emojis = (props: Props) => {

	return (
		<div>
			<Picker
				navPosition={props.isLiveChat && "bottom"}
				onEmojiSelect={(e: any) => props.handleEmojiSelect(e)}
				searchPosition={props.isLiveChat && "none"}
				theme={"light"}
				previewPosition={props.isLiveChat && "none"}
				maxFrequentRows={0}
				perLine={props.isLiveChat ? 7 : 9}
				emojiButtonSize={props.isLiveChat ? 48 : 35}
				emojiSize={props.isLiveChat ? 21 : 16}
			/>
		</div>
	);
}

export default Emojis;